module.exports = __webpack_public_path__ + "img/SOV Report.821be5cb.svg";